import { ReactElement } from "react";

import { GoTag } from "react-icons/go";

import { HStack, StackProps, Text } from "@chakra-ui/react";

import { FragmentType, getFragmentData, graphql } from "@/__generated__";
import { BranchIcon } from "@/components/shared/ReleaseIcons";

const EnvironmentSubtitle_Environment = graphql(`
  fragment EnvironmentSubtitle_Environment on Environment {
    trackingBranch
    trackingTag
    databaseId
    handle
  }
`);

interface Props {
  environment?: FragmentType<typeof EnvironmentSubtitle_Environment>;
}

function EnvironmentSubtitle({ environment: propEnvironment, ...stackProps }: Props & StackProps) {
  const environment = getFragmentData(EnvironmentSubtitle_Environment, propEnvironment);

  if (!environment) return null;

  let icon: ReactElement | null = null;
  if (environment.trackingBranch) {
    icon = (
      <>
        <div>
          <BranchIcon />
        </div>
        <div>{environment.trackingBranch}</div>
        <div>•</div>
      </>
    );
  } else if (environment.trackingTag) {
    icon = (
      <>
        <div>
          <GoTag />
        </div>
        <div>{environment.trackingTag}</div>
        <div>•</div>
      </>
    );
  }

  return (
    <HStack alignItems="center" spacing={2} {...stackProps}>
      {icon}
      <Text>{environment.handle}</Text>
    </HStack>
  );
}

export default EnvironmentSubtitle;
